import StudentIcon from '@shared/icons/navigation/StudentIcon';
import authRoles from '../auth/authRoles';
import HomeIcon from '@shared/icons/navigation/HomeIcon';
import SchoolIcon from '@shared/icons/navigation/SchoolIcon';
import SettingsIcon from '@shared/icons/navigation/SettingsIcon';
import StaffIcon from '@shared/icons/navigation/StaffIcon';
import StaffSchedulesIcon from '@shared/icons/navigation/StaffSchedulesIcon';
import CalendarIcon from '@shared/icons/navigation/CalendarIcon';
import MessagingIcon from '@shared/icons/navigation/MessagingIcon';
import RoomsIcon from '@shared/icons/navigation/RoomsIcon';
import LivestreamingIcon from '@shared/icons/navigation/LivestreamingIcon';
import ReportsIcon from '@shared/icons/navigation/ReportsIcon';
import GalleryIcon from '@shared/icons/navigation/GalleryIcon';
import UserManagementIcon from '@shared/icons/navigation/UserManagementIcon';

/** The `navigationConfig` constant is an array of objects that represents the navigation menu.
 *  Each object in the array represents a menu item with properties such as `id`, `title`, `translate`, `type`, `isCustomIcon`, `icon`, `url`, and `auth`:
 * - `auth`: defines who can see the menu item
 * - `url`: defines the URL of the menu item
 */
const navigationConfig = [
	{
		id: 'Home',
		title: 'Home',
		translate: 'Home',
		type: 'item',
		isCustomIcon: true,
		icon: <HomeIcon />,
		// icon: 'home.png',
		url: '/company',
		auth: authRoles.admin,
		permission: 'Company Dashboard',
	},
	{
		id: 'schools',
		title: 'schools',
		translate: 'schools',
		type: 'item',
		icon: <SchoolIcon />,
		isCustomIcon: true,
		// icon: 'school-admin.png',
		url: '/schools',
		auth: authRoles.admin,
		permission: 'Schools',
	},
	{
		id: 'reports',
		title: 'CompanyReports',
		translate: 'reports',
		type: 'item',
		isCustomIcon: true,
		icon: <ReportsIcon />,
		url: '/company-reports',
		auth: authRoles.admin,
		permission: 'Company Reports',
	},
	{
		id: 'usermanagement',
		title: 'User Management',
		translate: 'User Management',
		type: 'item',
		isCustomIcon: true,
		icon: <UserManagementIcon />,
		url: '/user-management',
		auth: authRoles.admin,
		permission: 'User Management',
	},
	{
		id: 'home',
		title: 'Home',
		translate: 'Home',
		type: 'item',
		isCustomIcon: true,
		icon: <HomeIcon />,
		url: '/home',
		auth: authRoles.subadmin,
		permission: 'Dashboard',
		alwaysShow: true,
	},
	{
		id: 'calendar',
		title: 'Calendar',
		translate: 'Calendar',
		type: 'item',
		isCustomIcon: true,
		icon: <CalendarIcon />,
		url: '/calendar',
		auth: authRoles.subadmin,
		permission: 'Calendar',
	},
	// {
	// 	id: 'students',
	// 	title: 'students',
	// 	translate: 'students',
	// 	type: 'item',
	// 	isCustomIcon: true,
	// 	// icon: 'students.png',
	// 	url: '/students',
	// 	auth: authRoles.subadmin,
	// 	permission: 'Students',
	// },
	{
		id: 'students',
		title: 'Students',
		translate: 'Students',
		type: 'item',
		isCustomIcon: true,
		// icon: 'students.png',
		icon: <StudentIcon />,
		url: '/students',
		auth: authRoles.subadmin,
		permission: 'Students',
		alwaysShow: true,
		subLinks: [
			{
				id: 'student-list',
				title: 'Student List',
				type: 'item',
				url: '/students/list',
			},
			{
				id: 'incident-reports',
				title: 'Incident Reports',
				type: 'item',
				url: '/students/incident-reports',
			},
		],
	},
	{
		id: 'staff',
		title: 'staff',
		translate: 'staff',
		type: 'item',
		isCustomIcon: true,
		icon: <StaffIcon />,
		url: '/staff',
		auth: authRoles.subadmin,
		permission: 'Staff',
		hiddenOnMobile: true, // TODO: Enable this when the PWA version is ready
	},
	{
		id: 'rooms',
		title: 'rooms',
		translate: 'rooms',
		type: 'item',
		isCustomIcon: true,
		icon: <RoomsIcon />,
		url: '/rooms',
		auth: authRoles.subadmin,
		permission: 'Rooms',
		hiddenOnMobile: true, // TODO: Enable this when the PWA version is ready
	},
	{
		id: 'staffschedule',
		title: 'staff schedule',
		translate: 'staff schedule',
		type: 'item',
		isCustomIcon: true,
		icon: <StaffSchedulesIcon />,
		url: '/staff-schedule',
		auth: authRoles.subadmin,
		permission: 'staff-schedule',
		hiddenOnMobile: true, // TODO: Enable this when the PWA version is ready
	},
	{
		id: 'messaging',
		title: 'messaging',
		translate: 'Messaging',
		type: 'item',
		isCustomIcon: true,
		icon: <MessagingIcon />,
		url: '/messaging',
		auth: authRoles.subadmin,
		permission: 'Messaging',
	},
	{
		id: 'LiveStreaming',
		title: 'Live Streaming',
		translate: 'Live Streaming',
		type: 'item',
		isCustomIcon: true,
		icon: <LivestreamingIcon />,
		url: '/livestreaming',
		auth: authRoles.subadmin,
		permission: 'Live_Streaming',
	},
	{
		id: 'gallery',
		title: 'Gallery',
		translate: 'Gallery',
		type: 'item',
		isCustomIcon: true,
		icon: <GalleryIcon />,
		url: '/gallery',
		auth: authRoles.subadmin,
		permission: 'Gallery',
		alwaysShow: true,
	},
	{
		id: 'schooladmin',
		title: 'School Admins',
		translate: 'School Admins',
		type: 'item',
		isCustomIcon: true,
		icon: <SchoolIcon />,
		url: '/subadmin',
		auth: authRoles.subadmin,
		permission: 'Sub_Admin',
		hiddenOnMobile: true, // TODO: Enable this when the PWA version is ready
	},
	{
		id: 'reports-subadmin',
		title: 'reports',
		translate: 'Reports',
		type: 'item',
		isCustomIcon: true,
		icon: <ReportsIcon />,
		url: '/reports',
		auth: authRoles.subadmin,
		permission: 'Reports',
		hiddenOnMobile: true, // TODO: Enable this when the PWA version is ready
	},

	{
		id: 'settings',
		title: 'settings',
		translate: 'settings',
		type: 'item',
		isCustomIcon: true,
		icon: <SettingsIcon />,
		url: '/settings',
		auth: authRoles.subadmin,
		permission: 'Settings',
		hiddenOnMobile: true, // TODO: Enable this when the PWA version is ready
	},
];

export default navigationConfig;
